import { useTranslation } from 'react-i18next';
import UtilityDrawerBody from '../utility-drawer/utility-drawer-body/utility-drawer-body.component';
import UtilityDrawerFooter from '../utility-drawer/utility-drawer-footer/utility-drawer-footer.component';
import UtilityDrawer from '../utility-drawer/utility-drawer.component';
import TransactionInformation from './transaction-information/transaction-information.component';
import TransactionItemInformation from './transaction-item-information/transaction-item-information.component';
import { Button } from '@mui/material';
import { Transaction } from 'api/transactions/transactions.types';

type TransactionDetailsDrawerType = {
  open: boolean;
  close: () => void;
  drawerData: Transaction;
};

const TransactionDetailsDrawer = ({
  open,
  close,
  drawerData,
}: TransactionDetailsDrawerType) => {
  const { t } = useTranslation();

  return (
    <UtilityDrawer
      open={open}
      onClose={close}
      data-testid="TransactionDetailsDrawer.Drawer"
      title={t('drawer.transactionDetailsDrawer.title')}
    >
      <UtilityDrawerBody>
        <TransactionInformation {...drawerData} />
        <TransactionItemInformation {...drawerData} />
      </UtilityDrawerBody>
      <UtilityDrawerFooter>
        <Button
          fullWidth
          color="primary"
          variant="outlined"
          onClick={close}
          data-testid="TransactionDetailsDrawer.CloseButton"
        >
          {t('drawer.transactionDetailsDrawer.closeBtn.label')}
        </Button>
      </UtilityDrawerFooter>
    </UtilityDrawer>
  );
};

export default TransactionDetailsDrawer;
